import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconMarkersOrangeSizeS from './IconMarkersOrange_size_s';

const props: CreateIconArguments = {
  l: IconMarkersOrangeSizeS,
  m: IconMarkersOrangeSizeS,
  s: IconMarkersOrangeSizeS,
  xs: IconMarkersOrangeSizeS,
  name: 'IconMarkersOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
